// frontend/admin-portal/src/components/settings/sections/AppearanceSettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import TextInput from "../items/TextInput";
import SelectInput from "../items/SelectInput";

export default function AppearanceSettings({ values = {}, onChange }) {
  const safeOnChange = typeof onChange === "function" ? onChange : () => {};
  return (
    <div className="fh-settings-list">
      <SettingItem label="Theme">
        <SelectInput
          value={values["appearance.theme"]}
          onChange={(v) => safeOnChange("appearance.theme", v)}
          options={[
            { value: "light", label: "Light" },
            { value: "dark", label: "Dark" },
            { value: "auto", label: "Auto" },
          ]}
        />
      </SettingItem>
      <SettingItem label="Primary Color">
        <input
          type="color"
          className="fh-color-picker"
          value={values["appearance.primaryColor"] || "#0d6efd"}
          onChange={(e) =>
            safeOnChange("appearance.primaryColor", e.target.value)
          }
        />
      </SettingItem>
      <SettingItem label="Sidebar Style">
        <SelectInput
          value={values["appearance.sidebarStyle"]}
          onChange={(v) => safeOnChange("appearance.sidebarStyle", v)}
          options={[
            { value: "dark", label: "Dark" },
            { value: "light", label: "Light" },
          ]}
        />
      </SettingItem>
      <SettingItem label="Printer Type">
        <SelectInput
          value={values["printer.type"]}
          onChange={(v) => safeOnChange("printer.type", v)}
          options={[
            { value: "thermal", label: "Thermal" },
            { value: "a4", label: "A4" },
            { value: "laser", label: "Laser" },
          ]}
        />
      </SettingItem>
      <SettingItem label="Printer Name">
        <TextInput
          value={values["printer.name"]}
          onChange={(v) => safeOnChange("printer.name", v)}
        />
      </SettingItem>
      <SettingItem label="Default Copies">
        <TextInput
          type="number"
          value={values["printer.copies"]}
          onChange={(v) => safeOnChange("printer.copies", Number(v))}
        />
      </SettingItem>
    </div>
  );
}
